module.exports = __webpack_public_path__ + "img/countDown.ca6f78f4.png";